var getFlexAlignment = function (alignment) {
    switch (alignment) {
        case 'left':
            return 'flex-start';
        case 'center':
            return 'center';
        case 'right':
            return 'flex-end';
        default:
            return undefined;
    }
};
export default getFlexAlignment;
//# sourceMappingURL=getFlexAlignment.js.map